module.exports = __webpack_public_path__ + "img/BF-present.e1045999.png";